import type { JSX } from 'react'

export const NotifyIcon = (): JSX.Element => (
  <use href='#notifyIcon' height='100%' width='100%' />
)
